import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5","key":"svg-0"}]]

const IconRotate = createReactComponent('outline', 'rotate', 'Rotate', __iconNode);

export default IconRotate;